
<template>
  <div class="footer bg-light text-dark pt-3 pb-2">
   <b-container>
    <b-row>
      <b-col sm="6">
        <div class="logo-about">
            <a>
              <span class="d-flex align-items-center">
                <img src="@/assets/images/logo-interra-2.svg" alt="interra logo" class="logo-footer">
                <div class="logo-detail d-inline-block d-md-none d-lg-inline-block">
                    <h2 class="supra-title black">Interra Travel</h2>
                    <p class="supra-subtitle">Vacanță plăcută !</p>
                </div>
              </span>
            </a>
          </div>
      </b-col>
      <b-col sm="6">
        <h5 class="border-bottom">Contact</h5>
        <ul class="list-unstyled ft-contact">
          <li class="ft-tel">
              <b-icon icon="telephone-fill" variant="warning" class="mr-2"/>
              <a href="tel:0213123775">021 312 3775</a>
          </li>
          <li class="ft-mail">
            <b-icon icon="envelope-fill" variant="warning" class="mr-2"/>
              <a href="mailto:rezervari@interra.ro">rezervari@interra.ro</a>
          </li>
          <li class="ft-location">
            <b-icon icon="geo-alt-fill" variant="warning" class="mr-2"/>
              <a href="https://www.google.com/maps/place/Interra+Travel/@44.4424651,26.1254154,19z/data=!3m1!4b1!4m5!3m4!1s0x40b1ff2d5a935469:0x3433004db2794e27!8m2!3d44.4424797!4d26.1259539" target="_blank">Bd. Ferdinand, nr. 83, Sector 2, București</a>
          </li>
          <li><div class="border-bottom"></div></li>
          <li>
              <a href="https://www.instagram.com/interratravel/" target="_blank">
                <b-icon icon="instagram"  class="mr-2"/>
              </a>

              <a href="https://www.facebook.com/InterraTravel" target="_blank">
                <b-icon icon="facebook"  class="mr-2"/>
              </a>
          </li>
      </ul>
      </b-col>
    </b-row>
   </b-container>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<style lang="scss">
.logo-footer{
  max-height: 5rem;
}
.logo-detail {
    margin-left: 15px;
    margin-top: 20px;
  }
.footer .supra-title {
    font-size: 24px;
    line-height: 30px;
}
.supra-subtitle {
    font-size: 16px;
    line-height: 21px;
    margin-bottom: 22px;
}
.list-unstyled {
    list-style: none;
    padding-left: 0px;
    li a {
      color:black;
      transition: color .3s ease;
      &:hover{
        color: orange;
      }
    }
}

</style>
